import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import SoftChip from '../../dashboard/SoftChip';

/**
 * Where the contact's conversation stands: "Assigned to me" (which already
 * implies an active conversation), else "Active conversation", else nothing.
 */
export default function ContactStatusChips({ contact, sx }) {
  const { t } = useTranslation();
  const active = Boolean(contact.active_lead_uuid);
  const mine = Boolean(contact.is_currently_assigned_to_me);

  if (!active && !mine) return null;

  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap" sx={sx}>
      {mine
        ? <SoftChip size="small" color="primary" label={t('contacts.status.assignedToMe')} />
        : <SoftChip size="small" color="success" label={t('contacts.status.activeConversation')} />}
    </Stack>
  );
}
